import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Menu } from 'app/shared/models/Menus/menus';
import { User } from 'app/shared/models/Users/user';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { GetlinkService } from 'app/shared/services/getLink/getlink.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

declare const invokeAppAction: any;
@Component({
  selector: 'app-drawer-content',
  templateUrl: './drawer-content.component.html',
  styleUrls: ['./drawer-content.component.scss']
})
export class DrawerContentComponent extends SubscriptionBaseComponent implements OnInit {

  faSignOutAlt = faSignOutAlt;

  name: string;

  menu: Menu[];

  user: User;

  logIn: any;
  isConnect: boolean;


  constructor(
    public router: Router,
    private authentificationService: AuthenticationService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private getLinkService: GetlinkService,
    private ffvService: FfvapiService

  ) {
    super();
  }

  ngOnInit(): void {
    this.user = this.authentificationService.getDecodedToken();
    this.dataService.userLogin.next(this.user);

    if (this.user !== null && this.user !== undefined) {
      this.dataService.isConnect.next(true);
    }
    this.initSub();
    if (this.logIn) {
      this.giveInfoUserIfLience();

    }
  }

  isMobile(): boolean {
    return this.dataService.isMobile();
  }

  invokeAppAction(url: string): void {
    invokeAppAction(url);
  }

  logout(): void {
    this.authentificationService.logout();
  }

  getLink(type: string, title: string, url: string, addPersonas: boolean, addFonctions: boolean, titleHome: string): void {
    this.getLinkService.getLink(type, title, url, addPersonas, addFonctions, titleHome);
  }

  private giveInfoUserIfLience(): void {
    this.ffvService.checkIfALicence().subscribe(res => {
      this.dataService.userIsLink.next(true);

      this.ffvService.getDetailsUser().subscribe(response => {

        response.prenom.toLocaleLowerCase()[0].toUpperCase();

        const userLogin = this.authentificationService.getDecodedToken();
        userLogin.given_name = response.prenom;
        userLogin.family_name = response.nom;
        this.dataService.userLogin.next(userLogin);
      });
    });
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }


  private initSub(): void {
    this.subscription
      .add(
        this.dataService.userLogin.subscribe(user => {
          if (user) {
            this.name = `${user.given_name} ${user.family_name}`;
          }
        }))
      .add(
        this.dataService.logIn.asObservable().subscribe(logIn => {
          this.logIn = logIn;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.isConnect.asObservable().subscribe(isConnect => {
          this.isConnect = isConnect;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.menu.asObservable().subscribe(menu => {
          this.menu = menu;
          this.cdr.detectChanges();
        })
      );
  }

}
